/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BiasTestRequest } from './BiasTestRequest';
import {
    BiasTestRequestFromJSON,
    BiasTestRequestFromJSONTyped,
    BiasTestRequestToJSON,
    BiasTestRequestToJSONTyped,
} from './BiasTestRequest';

/**
 * 
 * @export
 * @interface ExperimentCreate
 */
export interface ExperimentCreate {
    /**
     * 
     * @type {string}
     * @memberof ExperimentCreate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ExperimentCreate
     */
    durationSeconds?: number;
    /**
     * 
     * @type {Array<BiasTestRequest>}
     * @memberof ExperimentCreate
     */
    biasTests?: Array<BiasTestRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof ExperimentCreate
     */
    useSleepSchedule?: boolean;
}

/**
 * Check if a given object implements the ExperimentCreate interface.
 */
export function instanceOfExperimentCreate(value: object): value is ExperimentCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ExperimentCreateFromJSON(json: any): ExperimentCreate {
    return ExperimentCreateFromJSONTyped(json, false);
}

export function ExperimentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperimentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'durationSeconds': json['duration_seconds'] == null ? undefined : json['duration_seconds'],
        'biasTests': json['bias_tests'] == null ? undefined : ((json['bias_tests'] as Array<any>).map(BiasTestRequestFromJSON)),
        'useSleepSchedule': json['use_sleep_schedule'] == null ? undefined : json['use_sleep_schedule'],
    };
}

export function ExperimentCreateToJSON(json: any): ExperimentCreate {
    return ExperimentCreateToJSONTyped(json, false);
}

export function ExperimentCreateToJSONTyped(value?: ExperimentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'duration_seconds': value['durationSeconds'],
        'bias_tests': value['biasTests'] == null ? undefined : ((value['biasTests'] as Array<any>).map(BiasTestRequestToJSON)),
        'use_sleep_schedule': value['useSleepSchedule'],
    };
}

